const GIF_CDN_HOSTS = ["media.giphy.com", "media.tenor.com", "media0.giphy.com", "media1.giphy.com", "media2.giphy.com", "media3.giphy.com", "media4.giphy.com"];

export function isGifUrl(url: string): boolean {
  try {
    const parsed = new URL(url);
    if (parsed.pathname.toLowerCase().endsWith(".gif")) return true;
    if (GIF_CDN_HOSTS.includes(parsed.hostname)) return true;
    return false;
  } catch {
    return false;
  }
}
